export type Tone = 'ok' | 'warn' | 'crit' | 'neutral';

const toneClasses: Record<Tone, { badge: string; dot: string }> = {
  ok: { badge: 'bg-ok-soft text-ok', dot: 'bg-ok' },
  warn: { badge: 'bg-warn-soft text-warn', dot: 'bg-warn' },
  crit: { badge: 'bg-crit-soft text-crit', dot: 'bg-crit' },
  neutral: { badge: 'bg-surface-hover text-fg-muted', dot: 'bg-fg-subtle' },
};

interface Props {
  tone: Tone;
  children: string;
  /** Pulses the dot for live/in-progress states (disabled by reduced motion). */
  pulse?: boolean;
  /** Classes of the text, e.g. to show only the dot on small screens (the caller then labels it). */
  labelClassName?: string;
}

/** Status is always conveyed by text as well as colour. */
export function StatusBadge({ tone, children, pulse = false, labelClassName }: Props) {
  const c = toneClasses[tone];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-2xs font-medium ${c.badge}`}
    >
      <span
        aria-hidden="true"
        className={`size-1.5 rounded-full ${c.dot} ${pulse ? 'animate-pulse' : ''}`}
      />
      {labelClassName ? <span className={labelClassName}>{children}</span> : children}
    </span>
  );
}
